module.exports = __webpack_public_path__ + "img/germany-liver-cancer-male.9b69c063.png";